/*  Shared  */
import { Percentage } from 'application/Shared/Components/Text';

/*  React  */
import React from 'react';

export const WorkLoginPercentCell = (props) => {
    const { row } = props;
    const { workLoginPercent } = row.original;
    if (workLoginPercent == null) return null;
    return <Percentage percent={workLoginPercent} />;
};
